export const publicLegalRoutes = {
  index: '/legal',
  terms: '/legal/terms',
  privacy: '/legal/privacy',
  dpa: '/legal/dpa',
} as const;

export const publicLegalRouteLinks = [
  {
    href: publicLegalRoutes.terms,
    label: 'Terms & Conditions',
  },
  {
    href: publicLegalRoutes.privacy,
    label: 'Privacy Policy',
  },
  {
    href: publicLegalRoutes.dpa,
    label: 'DPA',
  },
] as const;
